import { reduce } from 'lodash'

Controller.$inject = ['$state']
function Controller($state) {
  const ctrl = this
  let count = 0

  ctrl.$onInit = () => {
    count = reduce(ctrl.locations, (total, location) => total + location.Quantity, 0)
  }
  ctrl.countAll = () => {
    return count
  }

  ctrl.edit = () => {
    $state.go('^.locationsEdit', {
      locations: ctrl.locations,
      part: ctrl.part
    })
  }

  ctrl.getPropertyName = propertyId => {
    const allProperties = ctrl.allProperties
    if (!allProperties) { return '' }
    const property = allProperties.find(p => p.Id === propertyId)
    return property ? property.Name : ''
  }
}

export default Controller